var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryVisaMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 45,
    viewBox: "0 0 65 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_620_51)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.08887,
    y: 7,
    width: 50.2889,
    height: 31,
    rx: 6,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_620_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8366 20.843C32.8166 22.3723 34.2451 23.2256 35.3212 23.7331C36.4268 24.2536 36.7982 24.5875 36.7938 25.0531C36.7855 25.7655 35.9119 26.08 35.0943 26.0922C33.668 26.1136 32.8387 25.7196 32.1794 25.4216L31.6655 27.7481C32.327 28.043 33.5519 28.3002 34.8221 28.3115C37.8036 28.3115 39.7542 26.8874 39.7647 24.6794C39.7764 21.8771 35.759 21.722 35.7864 20.4694C35.7959 20.0896 36.1704 19.6843 36.9911 19.5813C37.3974 19.5292 38.5187 19.4894 39.7901 20.0559L40.2891 17.805C39.6054 17.5641 38.7267 17.3334 37.6326 17.3334C34.8263 17.3334 32.8525 18.7769 32.8366 20.843ZM45.084 17.5273C44.5396 17.5273 44.0808 17.8346 43.876 18.3061L39.6171 28.1462H42.5964L43.1893 26.5607H46.83L47.1739 28.1462H49.7998L47.5083 17.5273H45.084ZM45.5008 20.3958L46.3606 24.3834H44.0059L45.5008 20.3958ZM29.2243 17.5274L26.8759 28.1461H29.715L32.0623 17.5271H29.2243V17.5274ZM25.0244 17.5271L22.0693 24.7549L20.874 18.6094C20.7337 17.9234 20.1798 17.5273 19.5647 17.5273H14.7342L14.6665 17.8356C15.6582 18.0439 16.7849 18.3797 17.4676 18.7391C17.8853 18.9586 18.0044 19.1505 18.1417 19.6721L20.4057 28.1462H23.4059L28.0056 17.5273H25.0244",
    fill: "url(#paint0_linear_620_51)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_620_51",
    x: 0.0888672,
    y: 0,
    width: 64.2888,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.560784 0 0 0 0 0.909804 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_620_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_620_51",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_620_51",
    x1: 30.8187,
    y1: 28.5317,
    x2: 31.1262,
    y2: 17.2565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_620_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.1333,
    height: 11.0222,
    fill: "white",
    transform: "translate(14.6665 17.333)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryVisaMobile);
export default __webpack_public_path__ + "static/media/delivery-visa-mobile.e7377d1c135ec04cae8dabcbd714dd25.svg";
export { ForwardRef as ReactComponent };